//Change quantity from special buttons
if (document.getElementsByClassName("addQty")) {
  startQty();
}

function startQty() {
  const adds = document.getElementsByClassName("addQty");
  const mins = document.getElementsByClassName("minusQty");
  for (let i = 0; i < adds.length; i++) {
    adds[i].addEventListener("click", function() {
      quantityAdjust(1, adds[i]);
    });
  }
  for (let i = 0; i < mins.length; i++) {
    mins[i].addEventListener("click", function() {
      quantityAdjust(-1, mins[i]);
    });
  }
}

function quantityAdjust(direction, el) {
  let qty = el.previousElementSibling;
  if (direction == 1) {
    qty = qty.previousElementSibling;
  }
  if (qty.value == 1 && direction == -1) {
  } else {
    qty.value = parseInt(qty.value) + parseInt(direction);
  }
}

//create a listener to reveal subscription options:
function rechargeFrequency() {
  const els = document.getElementsByClassName("rc_radio__autodeliver");
  const dropdowns = document.getElementsByClassName("rc_block__type__options");
  const prices = document.getElementsByClassName("product-row-price__span");
  for (let i = 0; i < els.length; i++) {
    els[i].addEventListener("click", function() {
      dropdowns[i].classList.add("rechargeOpen");
      prices[i].innerHTML =
        "<s>" +
        prices[i].getAttribute("data-product-price") +
        "</s>" +
        " <span class='red'>" +
        prices[i].getAttribute("data-subscription-price") +
        "</span>";
    });
  }

  const singleEls = document.getElementsByClassName("rc_radio__onetime");
  for (let i = 0; i < singleEls.length; i++) {
    singleEls[i].addEventListener("click", function() {
      dropdowns[i].classList.remove("rechargeOpen");
      prices[i].innerHTML = prices[i].getAttribute("data-product-price");
    });
  }
}

rechargeFrequency();

//Create a potentially bundling add-to-cart object that then feeds to a movealong bundler
function cartWatch(pid, name) {
  // var subscriptionsActive = document.getElementById('rc_purchase_type_autodeliver');
  
  const container = document.getElementById("pdp-row--" + pid);

    const shippingFrequency = container.getElementsByClassName(
      "rc_select__frequency"
    )[0];
  console.log(container)
  const button = container.getElementsByClassName("add-cart__button")[0];
  var data = [];
  button.addEventListener("click", function() {
    
    let handle = button.getAttribute("data-handle");
    let selector = container.getElementsByClassName("rc_radio__autodeliver")[0];
    let subscription_active = button.getAttribute("data-subscription");
    let qty = button.parentElement.previousElementSibling.getElementsByTagName(
      "input"
    )[0].value;
    
    if (selector && subscription_active == "true" && selector.checked == true) {
      //determine subscription info
      const subscription_id = button.getAttribute("data-subscrID");
      let options = shippingFrequency.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected === true) {
          var shipping_interval_frequency = options[i].value;
          break;
        }
      }
      const shipping_interval_unit_type = button.getAttribute(
        "data-subscription-interval"
      );
      var price = container
        .getElementsByClassName("product-row-price__span")[0]
        .getAttribute("data-subscription-price");
      data = {
        quantity: qty,
        id: button.getAttribute("data-value-subscription"),
        "properties[shipping_interval_frequency]": shipping_interval_frequency,
        "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
        "properties[subscription_id]": subscription_id
      };
    } else {
      var price = container
        .getElementsByClassName("product-row-price__span")[0]
        .getAttribute("data-product-price");
      data = {
        quantity: qty,
        id: button.getAttribute("data-value")
      };
    }

    quickAddToCart(data, handle, qty, name, price);
  });
}
//
// function quickAddToCart(data, handle, qty, name, price) {
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     dataType: "json",
//     data: data,
//     success: function(res) {
//       // console.log(res);
//       totalCart();
//       justAddedModal(data, handle, qty, name, price);
//     },
//     error: function(res) {
//       console.log(res);
//     }
//   });
// }

// function totalCart(qty) {
//   const container = document.getElementById("cartCurrentTotal");
//   const modalContainer = document.getElementById("modalTotalInCart");
//   $.ajax({
//     type: "GET",
//     url: "/cart.js",
//     dataType: "json",
//     success: function(data) {
//       const items = data["items"];
//       let totalPrice = 0;
//       for (let i = 0; i < items.length; i++) {
//         totalPrice = parseInt(totalPrice) + parseInt(items[i].line_price);
//       }
//       totalPrice = totalPrice * 0.01;
//       container.innerHTML = "$" + totalPrice.formatMoney(2);
//       modalContainer.innerHTML = "$" + totalPrice.formatMoney(2);
//     },
//     error: function(res) {
//       console.log("res");
//     }
//   });
// }
// totalCart();

// function justAddedModal(data, product_handle, qty, name, price) {
//   const passedPrice = price;
//   const modalContainer = document.getElementById("justAddedModal");
//   const modalBackground = document.getElementById("justAddedModalBg");
//   const variant = data["id"];
//   const handle = product_handle;
//   //modal variables to fill
//   const imageContainer = document.getElementById("justAddedModalImage");
//   const titleContainer = document.getElementById("justAddedModalTitle");
//   const priceContainer = document.getElementById("justAddedModalPrice");
//   const itemsAdded = document.getElementById("totalItemsAdded");
//   const totalItems = document.getElementById("modalTotalItems");
//   const frequency = data["properties[shipping_interval_frequency]"];
//   const unit = data["properties[shipping_interval_unit_type]"];
//
//   //get the info on the product/variant from the Shopify API and load the modal
//   $.ajax({
//     type: "GET",
//     url: "/products/" + handle + ".js",
//     dataType: "json",
//     success: function(data) {
//       //load the modal window with the featured image.
//       imageContainer.innerHTML = "<img src='" + data["featured_image"] + "'>";
//       //find the variant that was added specifically
//       const variants = data["variants"];
//       for (let i = 0; i < variants.length; i++) {
//         if (variants[i].id == variant) {
//           //load the rest of the modal based on variant values.
//           titleContainer.innerHTML = variants[i].name;
//           var price = parseInt(variants[i].price) * 0.01;
//           priceContainer.innerHTML = "$" + price.formatMoney(2);
//           if (qty == 1) {
//             itemsAdded.innerHTML = qty + " item added to your cart";
//           } else {
//             itemsAdded.innerHTML = qty + " items added to your cart";
//           }
//           var variantFound = true;
//           break;
//         }
//       }
//
//       if (variantFound !== true) {
//         titleContainer.innerHTML = name;
//         priceContainer.innerHTML = passedPrice;
//         if (qty == 1) {
//           itemsAdded.innerHTML =
//             qty +
//             " item added to your cart to be delivered every " +
//             frequency +
//             " " +
//             unit;
//         } else {
//           itemsAdded.innerHTML =
//             qty +
//             " items added to your cart to be delivered every " +
//             frequency +
//             " " +
//             unit;
//         }
//       }
//       //qty has to be separate from the loop
//       //animate the modal in
//       modalContainer.classList.add("justAddedModalOpen");
//       //set a timeout on the modal so it fades away.
//       setTimeout(function() {
//         modalContainer.classList.remove("justAddedModalOpen");
//       }, 3000);
//
//       //animate modal background in
//       modalBackground.classList.add("justAddedModalBgOpen");
//       setTimeout(function() {
//         modalBackground.classList.remove("justAddedModalBgOpen");
//       }, 3000);
//     },
//     error: function(res) {
//       console.log("res");
//     }
//   });
// }

rjQuery = jQuery.noConflict(true);

var subscription_active = "{{shop.metafields.subscriptions.subscription_active}}";

function get_cookie(k) {
  return (document.cookie.match("(^|; )" + k + "=([^;]*)") || 0)[2];
}

if (get_cookie("recharge") == "true" || subscription_active == "true") {
  rjQuery("body").on(
    "click",
    'form[action="/checkout"] input[type="submit"], #ajaxifyCart [name="checkout"], #AjaxifyCart [name="checkout"], #shoppingBagInner [name="checkout"]',
    function(e) {
      e.preventDefault();
      window.location.href = "/cart";
    }
  );

  rjQuery(".additional-checkout-buttons").hide();
  rjQuery(document).ready(function() {
    rjQuery(".additional-checkout-buttons").hide();
  });
}
